import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { RouterModule } from '@angular/router';

import { MgIconModule } from '@app/src/app/icon';
import { PermissionsModule } from '@app/src/app/permissions';

import { GenericModule } from '@shared/components/generic';
import { TextModule } from '@shared/components/text';

import { HomeActionButtonComponent } from './home-action-button.component';

@NgModule({
  imports: [
    // Minga dependencies
    GenericModule,
    TextModule,
    MgIconModule,
    PermissionsModule,

    // External dependencies
    CommonModule,
    MatMenuModule,
    RouterModule,
    FlexLayoutModule,
  ],
  declarations: [HomeActionButtonComponent],
  exports: [HomeActionButtonComponent],
})
export class HomeActionButtonModule {}
